import { render } from "./LeaveDetailsModal.vue?vue&type=template&id=1f89571f&scoped=true"
import script from "./LeaveDetailsModal.vue?vue&type=script&lang=js"
export * from "./LeaveDetailsModal.vue?vue&type=script&lang=js"

import "./LeaveDetailsModal.vue?vue&type=style&index=0&id=1f89571f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f89571f"]])

export default __exports__